import React, { useState } from 'react';

import { AppBar, Box } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CachedIcon from '@material-ui/icons/Cached';

import PortalComponent from 'components/Portal/PortalComponent';
import SecondHandIcon from 'components/atoms/SecondHandIcon';

import { SparePart, buildSkuReference } from 'types/spare-part';

import { generateQrCode } from 'utils/QrCodeUtils';
import { generateUniqueI } from 'utils/skuUniqueIdGenerator';

import StoreStyles from '../StoreStyles';
import PrintContent from './PrintContent';

const useStyles = makeStyles(StoreStyles);

interface ManualConfirmationModalProps {
  employeeName: string;
  TransitionComponent: React.ForwardRefExoticComponent<
    React.PropsWithoutRef<unknown> & React.RefAttributes<unknown>
  >;
  open: boolean;
  onClose: () => void;
  handleValidatePacking: (code: string) => void;
  sku: SparePart;
  mode: string;
}

const ManualConfirmationModal: React.FunctionComponent<ManualConfirmationModalProps> = (
  props: ManualConfirmationModalProps
) => {
  const classes = useStyles();
  const [qrCode, setQrCode] = React.useState();
  const [isResumeModalOpen, setIsResumeModalOpen] = useState(false);
  const [code, setCode] = useState<string>();
  const updateQrCode = (code: string) => {
    generateQrCode(code, setQrCode);
  };

  const handleOpenResumeModal = () => {
    if (props.mode === 'packing') {
      generateUniqueI(props.sku).then(handlePrint);
    } else if (props.mode === 'transfer') {
      generateUniqueI(props.sku).then(() => props.handleValidatePacking(props.sku?.unique_id));
    }
  };

  const handlePrint = (code: string) => {
    setCode(code);
    setIsResumeModalOpen(true);
    updateQrCode(code);
  };

  const handleCloseResumeModal = () => {
    if (typeof code !== 'undefined') {
      props.handleValidatePacking(code);
    }
  };

  return (
    <PortalComponent open={props.open} onClose={props.onClose}>
      <AppBar color="transparent" className={classes.header}>
        <div className={classes.elementHeader}>
          <IconButton edge="start" onClick={props.onClose} className={classes.back}>
            <ArrowBackIcon />
          </IconButton>
          <span>{props.employeeName}</span>
        </div>
      </AppBar>
      <div className={classes.lossDialog}>
        <div className={classes.lossCard}>
          <div className={classes.lossHeadingText}>Référence</div>
          <div className={classes.lossDetailText}>
            {buildSkuReference(props.sku)}
            <Box ml={1}>{props.sku?.is_second_hand && <SecondHandIcon />}</Box>
          </div>
        </div>

        <div className={classes.lossToolbar}>
          <div className={classes.wrapper} style={{ paddingLeft: 16, paddingTop: 10 }}>
            <Button
              className={`${classes.button} ${classes.buttonOrange}`}
              onClick={handleOpenResumeModal}
            >
              {props.mode === 'packing' ? 'Valider le colisage' : 'Valider la sélection'}
            </Button>
          </div>
        </div>
      </div>
      <PrintContent
        open={isResumeModalOpen}
        onClose={handleCloseResumeModal}
        firstText={code}
        secondText="Bien étiqueter cette pièce"
        codeSubtitle={code}
        qrCode={qrCode}
        handleNextStep={handleCloseResumeModal}
        headingText={props.sku?.is_second_hand ? 'OCCASION' : undefined}
        LeftIcon={props.sku?.is_second_hand ? CachedIcon : undefined}
        RightIcon={props.sku?.is_second_hand ? CachedIcon : undefined}
      />
    </PortalComponent>
  );
};

export default ManualConfirmationModal;
